Drupal.behaviors.toybox_summary = {
  // eslint-disable-next-line no-unused-vars
  attach: function (context, settings) {
    var summaries = context.querySelectorAll(
      ".js-summary:not(.is-initialized)",
    );

    summaries.forEach(function (summary) {
      summary.classList.add("is-initialized");

      var summaryActions = summary.querySelector(".js-summary-actions");

      summaryActions.addEventListener("click", function (e) {
        e.preventDefault();

        summary.classList.toggle("has-open-summary");

        // Make sure that the user is 'placed' at the top of the
        // box when folding it together.
        if (!summary.classList.contains("has-open-summary")) {
          summary.scrollIntoView({ behavior: "instant" });
        }
      });
    });
  },
};
